export default class FacilityType {

  id = "";

  name = "";
  description = "";
  dataTabs = [];
  workerRoles = [];
  documentationRules = [];
  contractTypes = [];

  constructor() {
  }
}
